<template>
    <div
        class="bonusomat-raffle-counters"
        :class="{ 'bonusomat-raffle-counters--one-group-only': !showAllwynCounters || !showDefaultCounters }"
    >
        <div class="bonusomat-raffle-counters__left">
            <TypographyHeadline type="section" theme="dark" class="bonusomat-raffle__headline">
                {{ headlineText }}
                <DsButton
                    type="text"
                    theme="dark"
                    icon-right="help"
                    @click="openBonusomatOnboardingClick"
                    class="button-onboarding"
                />
                <DsButton
                    v-if="showDefaultCounters || showAllwynCounters"
                    theme="dark"
                    type="interaction"
                    size="sm"
                    icon-right="gift"
                    @click="openModal"
                >
                    O co hrajeme?
                </DsButton>
            </TypographyHeadline>

            <WebpImage
                :src="bonImgUrl('raffle/raffle-mr-red-green', 'png')"
                alt="Pan Zelený a červený stojící vedle Bonusomatu"
                class="bonusomat-raffle-counters__image-wrapper bonusomat-raffle-counters__image--mobile"
                css-class="bonusomat-raffle-counters__image"
            />
            <BonusomatRaffleCountersGroup
                :hasRaffleDataLoadingFailed
                :showDefaultCounters
                :totalWin
                :raffleRemainingSeconds
                :showAllwynCounters
                :allwynName
                :allwynRemainingSeconds
                :showTicketsCounters
                :raffleTicketsCount
                :allwynTicketsCount
                :isWidget
            />
        </div>
        <div class="bonusomat-raffle-counters__right">
            <WebpImage
                :src="bonImgUrl('raffle/mr-red-raffle', 'png')"
                alt="Pan červený stojící vedle losovadla"
                class="bonusomat-raffle-counters__image-wrapper bonusomat-raffle-counters__image--desktop"
                css-class="bonusomat-raffle-counters__image"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import TypographyHeadline from "@sazka/design-system/src/typography/typography-headline.vue";
import { BonusomatDatalayer } from "@/casino/bonusomat/utils/analytics/bonusomat-datalayer";
import { useLoyaltyPlayerStatus } from "@/loyalty/composables/use-loyalty-player-status";
import BonusomatRaffleCountersGroup from "./bonusomat-raffle-counters-group.vue";
import useBonusomatOnboarding from "../../composables/use-bonusomat-onboarding";
import { bonImgUrl } from "../../utils/image-src";

const { bonusomatPlayerStatus } = useLoyaltyPlayerStatus();
const { bonusomatPlayerData, remainingSpinsCount } = bonusomatPlayerStatus;

const { openBonusomatOnboarding } = useBonusomatOnboarding();

const props = defineProps<{
    hasRaffleDataLoadingFailed: boolean;

    showDefaultCounters?: boolean;
    totalWin: number;
    raffleRemainingSeconds: number;

    showAllwynCounters?: boolean;
    allwynName?: string;
    allwynRemainingSeconds?: number;

    showTicketsCounters?: boolean;
    raffleTicketsCount?: number;
    allwynTicketsCount?: number;

    isWidget?: boolean;
}>();

const emit = defineEmits(["openWinTableModal"]);

const headlineText = computed(() =>
    props.showDefaultCounters && props.showAllwynCounters ? "Losovačky" : "Losovačka"
);

const openModal = async () => {
    emit("openWinTableModal");
};

const openBonusomatOnboardingClick = () => {
    openBonusomatOnboarding("raffle");
    BonusomatDatalayer.pushMoreInfoClick("Losovačka", bonusomatPlayerData.value.points, remainingSpinsCount.value);
};
</script>
